<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
          [{
            "num_cand": "U2FsdGVkX19phgbqlTESkb8SwWVo/lcEw9aV3kYRTI4=",
            "cpf": "U2FsdGVkX19daZNh7Vx1toYA1b5hXPXzMUMtOe/Z9yk="
          }, {
            "num_cand": "U2FsdGVkX198v9FqJ9LHSrlpWH17NP+Bvj1luN6ffdE=",
            "cpf": "U2FsdGVkX1+CTA9Rl0Yo+z4eINZo59Ak4wLcWYhLoGw="
          }, {
            "num_cand": "U2FsdGVkX19VhyYOYr4WW7NsK+mD+0RQRPuO/Cf0tfA=",
            "cpf": "U2FsdGVkX184zze2v6UYQ6ZQuTYA1RmfOlI/fRo/j2g="
          }, {
            "num_cand": "U2FsdGVkX19bqGiTrjFRpKv/POXvjh2O4yAmj8QfJpk=",
            "cpf": "U2FsdGVkX19qYy+T2umLs0GwslnmxgM+urw5z+dvalA="
          }, {
            "num_cand": "U2FsdGVkX19ZJC6+ezTn9uP9Nn5l1Jr9/scOfh+Nbg8=",
            "cpf": "U2FsdGVkX1+9ulI1tj6asThOmjbnUwdV/aHx4hQUKLk="
          }, {
            "num_cand": "U2FsdGVkX1/4FSP2Pm+CQSKU1V9LXEYQbNLEJ42MJ+4=",
            "cpf": "U2FsdGVkX18JagTWiuSOjZXZ6UIpjDtmKlPxgOD6N84="
          }, {
            "num_cand": "U2FsdGVkX1/jqZ9awqHFdCcuVC3IIWkEfNVEpOq7bfQ=",
            "cpf": "U2FsdGVkX1+0N9/AkLFX2A9R8Q8Mm53YtvfKKUQAxME="
          }, {
            "num_cand": "U2FsdGVkX1/nLG0jRYIzox4/Tf4OKICbQjb5wnNHQow=",
            "cpf": "U2FsdGVkX1/Xm+hHJNTwgCy1seiVm6Fbj1ZVxw4Lm6Q="
          }, {
            "num_cand": "U2FsdGVkX19Ht6gQmrQ7ElZfeLAapchAV1tgAOjlaoE=",
            "cpf": "U2FsdGVkX1873RulFK8bT3qt2UOIo71L104DV9z4Yk4="
          }, {
            "num_cand": "U2FsdGVkX19/LN3nEa3EfMw8AM2I6EUF3FrLUk677aU=",
            "cpf": "U2FsdGVkX18y62wcQ/XdykZ0QIqmZ2JdyZrPJeh9YUU="
          }, {
            "num_cand": "U2FsdGVkX18OYiMRfIyFW665dwF0L1nKzY7YwHkeyo4=",
            "cpf": "U2FsdGVkX1/TGh2IgLqewPO6skF3JtKUFny0mPv8zd4="
          }, {
            "num_cand": "U2FsdGVkX1/7KMiOaSAbzrbk0vh9r0hbLJmXadPmhAQ=",
            "cpf": "U2FsdGVkX18gFcO1UN2kAhobWY4huJGNmWeHeXz8HgM="
          }, {
            "num_cand": "U2FsdGVkX1+l6dKX3gBKjMsiiZbi9c9zUunyxsAa+LI=",
            "cpf": "U2FsdGVkX1/pAyKElXF81DHFkh7daX9iGTg39s3ywoc="
          }, {
            "num_cand": "U2FsdGVkX1/jYCJtekzgIlOya4QFFNAde8gC9lZlfA8=",
            "cpf": "U2FsdGVkX1+FfnzusAxrB1tqaMvp6mDOrcqq+jx+7gk="
          }, {
            "num_cand": "U2FsdGVkX19s3DEhD5KYVNxN8Ye5V9JnMTlv/FtwGFg=",
            "cpf": "U2FsdGVkX1+Rx7dOqa+O8U/9Q4OKZAjmk+7npQf62VE="
          }, {
            "num_cand": "U2FsdGVkX1/2d5PPkmf9Z1YhOx96tcOtiePLAbUdQ8M=",
            "cpf": "U2FsdGVkX1+Eac/E0PlL5pZCoNaeDloXybzohFWtbhM="
          }, {
            "num_cand": "U2FsdGVkX1/OMFeAe6PLQ4EZJ5/FVVF5mxcaiauWthY=",
            "cpf": "U2FsdGVkX18TjNdzZvClmgj7X7Zsvs88L2VKEhx2bu4="
          }, {
            "num_cand": "U2FsdGVkX18exy6sJkVrRJNx5/PEfYqJnsxPLlI0FqQ=",
            "cpf": "U2FsdGVkX18YU8mRtdzyZubpesrbD1RFPshNMi4iNT4="
          }, {
            "num_cand": "U2FsdGVkX19wG5rCXOnplOKwOfXZ8f1fN5iU6WWOJas=",
            "cpf": "U2FsdGVkX18BxxzsdrdJmnvzruv3FGJxVFduTh+n62U="
          }, {
            "num_cand": "U2FsdGVkX1/OfkzX8r/Mz/pjbmfRKUj3qctkhkKLoP0=",
            "cpf": "U2FsdGVkX19FMtwcx/vKiCVD2fY6v9AnigAZC+gOiDY="
          }, {
            "num_cand": "U2FsdGVkX19KhCCVCU+IjeOEjm9Zcr1dz2TGfxntn+g=",
            "cpf": "U2FsdGVkX1+qPHZCVK0VX79Q+aRZ8UWinjmFrxQAGeg="
          }, {
            "num_cand": "U2FsdGVkX1+gi0ZF6liaxmjz+HawT5T50KtV2d13ZS0=",
            "cpf": "U2FsdGVkX1+mI598exbhqRq1bWfKUyxvxH0cKh8K/uw="
          }, {
            "num_cand": "U2FsdGVkX1/86bkfSSXmgSJDEBwVPVVUH2LyFO/k/Z0=",
            "cpf": "U2FsdGVkX1+A4lyFq81YqCrkKMARLSZ6ORZNUjBjP5g="
          }, {
            "num_cand": "U2FsdGVkX18pzGzgjdEFcqnowIpoqlox3z+0AlxYG50=",
            "cpf": "U2FsdGVkX185fKGNo+wF2e1HWmVXQ9pBoY4iwIUUt0E="
          }, {
            "num_cand": "U2FsdGVkX1/o26KuO9I8FsPumkpj9pKfbXHtJ1aGgZo=",
            "cpf": "U2FsdGVkX19WwU3oEofhBgeRXDsN62+ZOmROwwwwwmE="
          },

            {"num_cand":"U2FsdGVkX19jAbBlLUUD9CwYChJb7Z7XYCvfkjyghHc=","cpf":"U2FsdGVkX18oLy646GUcCvhX4VqFQXhM++rZkhLmoo8="},{"num_cand":"U2FsdGVkX1/b/IUtgYlYokAXX19jeVjQEqjZx45tTTk=","cpf":"U2FsdGVkX1+XEluD+mDy7XRCHDi4crn5vp5B6KiPU6Y="},{"num_cand":"U2FsdGVkX19ci5k+VVjWtgZ549y3GqwLjFWZwcK3R3Q=","cpf":"U2FsdGVkX1/SFxBQJHH5ZEq4fZ4jn6ZJR1em9hr1o0M="},{"num_cand":"U2FsdGVkX1+bLv3QjsWux2Ir9H37wTRC0wgtYPkl5rU=","cpf":"U2FsdGVkX18F5cTRupqQ+J5TSVdRYi0BHAjeu+GO3as="},{"num_cand":"U2FsdGVkX1/HbvlfKehFYJL0f30xfzZfv7kqRtcayik=","cpf":"U2FsdGVkX1956FxvkpmOL86I+o3Tw1nfgKot3pJx1hE="},{"num_cand":"U2FsdGVkX18ZqO4W4YGUtZPq3Q1mWQKfVdbH82Bn3t8=","cpf":"U2FsdGVkX19Z5UJ536pvjkRVLdTTaORgfQWEoyGe2Zc="},{"num_cand":"U2FsdGVkX18J6rei/GESqqHCSBoTQ4Qcg4K2Ic+ZewQ=","cpf":"U2FsdGVkX1+asrrO51MWAxm7MVZVdfQirk7Hlo3BBfg="},{"num_cand":"U2FsdGVkX1+0XRriQo/dWhs2YNF5Mj05zYs5mamuAKg=","cpf":"U2FsdGVkX197c8sAzzf1GndwlBvM6M3plYNA8SgtknM="},{"num_cand":"U2FsdGVkX1/cGXty6sCRjNbL0ad+DbCETwKx+y4XSS4=","cpf":"U2FsdGVkX1/IwD7YDV75DeRBZOv3dx2t4Hw1TguWoQc="},{"num_cand":"U2FsdGVkX18GJKUMQ3rHQdgwnP9G7c5wzKvprTzu6wo=","cpf":"U2FsdGVkX1/lv9DhfZRBD8VxefLI8EdSCpYRgjbP/HE="},{"num_cand":"U2FsdGVkX1+mghaYzj3+hJ5SmHXm8yHNP8i06Osc7sc=","cpf":"U2FsdGVkX19Owmo5Fwe6v9tDGBA064ZRps2hutkoaHg="},{"num_cand":"U2FsdGVkX1+UoQV8aqRAXLjciP2DNYFraANbtGWbaYE=","cpf":"U2FsdGVkX1+KDUxZ7kAGqVAgDYqyWZbwBbQ0GGS3w3A="},{"num_cand":"U2FsdGVkX19/NseP4SjBYRnycgK1KqltX2IRc0YXXDo=","cpf":"U2FsdGVkX19bfvGT/BnNjvDYpuFIlLlo0G1Vt+BsCtc="},{"num_cand":"U2FsdGVkX1/JpDjWgaTqfOwoQ6VNbLzoGlJWupS04WQ=","cpf":"U2FsdGVkX19RDULSZw3mADFiYMl6R3PGHCz+EGptxqM="},{"num_cand":"U2FsdGVkX183lzEbXUz6M9qWtzmiYMnifbbAFVPAMPw=","cpf":"U2FsdGVkX1+e+ZKTzqZICJgM9vanWDY6Smo2jLh/DCs="},{"num_cand":"U2FsdGVkX1+lEAH0AirXjYXBuW4QA6giWWZXEQ1la7M=","cpf":"U2FsdGVkX19v6rfUIBJwvoWZbQtJ9qNr2W9apCgqtMg="},{"num_cand":"U2FsdGVkX18w+UYOALRhb7E8Cq9ftC8KUOXd6sbOceM=","cpf":"U2FsdGVkX1+X7ZlzXRA6MKMV+WD2Jfv71TMXlq76VK4="},{"num_cand":"U2FsdGVkX18wvmD8N1212bpYFRqWMRkg4Z/IBJzEy8E=","cpf":"U2FsdGVkX1/pZHyFu7GWlJ7L4bznqlqm88X7cKWD3oI="},{"num_cand":"U2FsdGVkX18oQF88lMRU0dlCOoJOhK1e6WRGaEfQzKE=","cpf":"U2FsdGVkX19F/30fq/nWqADrqZ9Uq5dUdxpB5aXqXr0="},{"num_cand":"U2FsdGVkX19o1nIyZra3XE5b+E3Y3XSFypBXTNMu9dM=","cpf":"U2FsdGVkX18ZnPqZnlHRrncEDo1VkGgWKulKMCT+g/g="},{"num_cand":"U2FsdGVkX1+bLZhHwvdwZJYQcBgDCh7KENbbQLJR43o=","cpf":"U2FsdGVkX18V/Ij9pw0+rwCvIN3qtGU7Ht0sDJr548Y="},{"num_cand":"U2FsdGVkX1//XNUquT2/fBb5GBorLz+d6SOcyGfNDlA=","cpf":"U2FsdGVkX18lTsidc+MJLiHS6ke0Tw2LzZB/MrsqcYI="},{"num_cand":"U2FsdGVkX19CbkvDOxnhwDubb5DC85x3F7TxGIEZ7zs=","cpf":"U2FsdGVkX19gA1j3Z4SEalAP6MrOLMhC/Ey5OtedYnE="},{"num_cand":"U2FsdGVkX1+fKvRMWyvfvC8uLB7hz5G+UJbTzcKaxqI=","cpf":"U2FsdGVkX185V1050iS8yz09yaMcXP9r8ZnQp3PKBco="},{"num_cand":"U2FsdGVkX184LdquZarQ2UxoJx4HPQfwHhN3ThvHrNQ=","cpf":"U2FsdGVkX1+LdFGRTD55dt+QBjEQfNeNY+KIipfLMac="},{"num_cand":"U2FsdGVkX1+OZK2w+1SnWfzdQCjQ7LlT3TwMMZawh14=","cpf":"U2FsdGVkX1/TM7v/MHteDvqqTdA9y4BMPfoR4e4F5sE="},{"num_cand":"U2FsdGVkX1/k4PqRahqJsBAiw0ldOFFhMlrYgz8+pz4=","cpf":"U2FsdGVkX1+zH7msZcIlNhCb7QtdZ1Ers1GbTf1tJzw="},{"num_cand":"U2FsdGVkX1+dg0PEkgh/vmroKV14T7s4TKXMr01kUYs=","cpf":"U2FsdGVkX19AVydq0l+ebs+bVE5zw/ViOCml733p1NU="},{"num_cand":"U2FsdGVkX18lO9OOU1dba6PoRFfNJcd/4kooeFCQvb4=","cpf":"U2FsdGVkX18/Px1gxvpt+8W/ZXotmxxroL2+9xHf2Ps="},{"num_cand":"U2FsdGVkX1/ZdglBswk6RhxmsiYDmNM150Ho0kd/rXs=","cpf":"U2FsdGVkX19eEpe77ftlbYCKwV/d+F990u+Hm+kT4Xo="},{"num_cand":"U2FsdGVkX1/ONm5IHBbBstBpdxcvM4NwqaIryZWNfRI=","cpf":"U2FsdGVkX1+3oTQwz8iAb2VY6h0sklfjKp9GUjcyM7k="},{"num_cand":"U2FsdGVkX18ZijvW6fptO0gDay2JpgtHscW+YaZtTDg=","cpf":"U2FsdGVkX18IJ3YY54bN+U5QtUTI9UcBhUdKTSTzRUQ="},{"num_cand":"U2FsdGVkX1/pMWc1T7RktWOgnrKUuBh1rPAsDcUWbaw=","cpf":"U2FsdGVkX1+fnzkfhvi7e7Z/qsQgc37pAx0v/J4zQxw="},{"num_cand":"U2FsdGVkX19h9Wv2iEUwbk9bvnFZJeCAbLUk6HdwGw8=","cpf":"U2FsdGVkX18fBWb8aG6VeiGEeboeGpNIqoCBaqp/Nqo="},{"num_cand":"U2FsdGVkX1+j8kzZFJrMpH/e7v/ZJoD8/8QEOa8NfZg=","cpf":"U2FsdGVkX1+Qea6ZjTJSXYm6dsWAZw68ERSKIiPpw2I="},{"num_cand":"U2FsdGVkX19fk5bIX2gGNt8nblrWaIfMsno7u/Vv6V4=","cpf":"U2FsdGVkX18ZsSBBLC9ulTZItNK1XspbRUuD/JhK9CQ="},{"num_cand":"U2FsdGVkX1/5GXsYb8/RtBiX6Vs9xU1REEiQKGllAlI=","cpf":"U2FsdGVkX197viqjjKRWgdSaLNF8QKTT/CMm8d24/XA="},{"num_cand":"U2FsdGVkX1/RYblcOTjc1+W8ufDF66jy/TWoinNdct4=","cpf":"U2FsdGVkX18V0MLCp+aSVJ0tmii4oQhOVG9tOd/Fyx4="},{"num_cand":"U2FsdGVkX1/2THO2yNFvNbB+4pP+JZMB3fwZ+MU6uFE=","cpf":"U2FsdGVkX18apXi9BW5xWaEbThQJ+q78n0HEMSenaCA="},{"num_cand":"U2FsdGVkX1/jNV5mtMCsoLNeRAschcXGVqGpnjXmqrE=","cpf":"U2FsdGVkX18gO3Kw3z7SaT77IrkNxFrpDJUtCiaQCmo="},{"num_cand":"U2FsdGVkX1+S+L2s8R8h70xQc7XAK/1urK+G70Nru5s=","cpf":"U2FsdGVkX19/bLunq7SIfuoj6uUON/t1JV92JpsfwrI="},{"num_cand":"U2FsdGVkX19XagLFs/DM/6xHS8BoetuRtryQQCDcvqo=","cpf":"U2FsdGVkX199Qri8lyu1tTH8CxpOP2cENRp5EA3GkNQ="},{"num_cand":"U2FsdGVkX1/WrWtDZWVKj+UpsztDx3WWcUPXfEvGA3c=","cpf":"U2FsdGVkX1/k+vrqRzCwsJqzNWI+kB+ZWGhuG3ipS4Y="},{"num_cand":"U2FsdGVkX1+kT0h8KeojDXMKVOY9HrTZw+1KtTWeOOE=","cpf":"U2FsdGVkX1/j2MODFRtvEtzF3Oe/lw1Ib3Uh7IP+460="},{"num_cand":"U2FsdGVkX1+O1gbx4lVbIqD4X1LFRp0jFzZIqKv4068=","cpf":"U2FsdGVkX19cSEWhSJSMfR9gpNa3zOHckYXOPzfITBU="},{"num_cand":"U2FsdGVkX1+hNBjzVnBkb70mCLOzgEgRochPp5fYpEA=","cpf":"U2FsdGVkX19+fzJrkJ4IFyYbr06OZQY3X5goVMVBjQg="},{"num_cand":"U2FsdGVkX1+y68shmV6l00O0hAlGfRw8y7CKzktFbZs=","cpf":"U2FsdGVkX19We6XNOpOShXtQmtFQrhmwBe0jTukslc0="},{"num_cand":"U2FsdGVkX1+sGZug+ZwLcUMtaH7OLT6juuHra7FUuUc=","cpf":"U2FsdGVkX18yXPKaVzrNUADzBZWlynFRMEUyEj8Tz8w="},{"num_cand":"U2FsdGVkX1/UdI+kHY89Uo2q27/lbLm66zQ5r5Qzdg4=","cpf":"U2FsdGVkX1+9ncVTbq/3wMqWKhAEEShG53fg7LIY/mU="},{"num_cand":"U2FsdGVkX1/lDtjeszBwKupDskvvWDqgCj5B2XMB+A8=","cpf":"U2FsdGVkX18kGVghYfWWYPBci1xpaEl+8sLhZdraxeM="},{"num_cand":"U2FsdGVkX18F0BhRy7sE3sJsgRQ5k6177cIi+b4hI5A=","cpf":"U2FsdGVkX1/jfScpbaxz1M4zsMeFoITPWzsR2giiFpY="},{"num_cand":"U2FsdGVkX19e7NcWh4EWx5HTRWObtSdYIekvyR3G2xU=","cpf":"U2FsdGVkX1+mnAg6D/oBnfqQJqGSDsKs0ePAeDTvciU="},{"num_cand":"U2FsdGVkX1+U33t9fv0rDxWWfbiHlTxBzjYMNYY65v8=","cpf":"U2FsdGVkX1+mgfpA4HRFOu9p6kaTwvWuJnTPsPq08Rw="},{"num_cand":"U2FsdGVkX18GwRhokM4GOgPLpBMMI6N8rKSCcBsd19s=","cpf":"U2FsdGVkX1/iAnQCVwkggwpqqk/zItSioARBzEAWO9g="},{"num_cand":"U2FsdGVkX1+l/9t+UqrfNhkGO0ZUb13SsnSfvDPD8z8=","cpf":"U2FsdGVkX19sLD8tuj9v0t9I4zy0Qt+1HSc6PNhP6W8="},{"num_cand":"U2FsdGVkX1/2p3qHxGHlbXhopcS/vW726yBpbCDzVck=","cpf":"U2FsdGVkX1/MMDdPP7PAs52G0QrukY+Ff2Kijp22V0s="},{"num_cand":"U2FsdGVkX1/9xK1Ns6GU+tzm0xp1RPVlgP/dq6kxMks=","cpf":"U2FsdGVkX1/OqSI/PbjHhH/XcG0iUA20FvTyj6IviMg="},{"num_cand":"U2FsdGVkX18TmXytbHlFVRm0iC8uCExipn6ByWQ5ilQ=","cpf":"U2FsdGVkX1/fRWGd+IUQ92jsWTCm0J+AhSuxYThED+E="},{"num_cand":"U2FsdGVkX19ZA/nNQ6WuiYy2/ZVZQoD4guxvfKhVGa0=","cpf":"U2FsdGVkX19CRSO/VqhSHjyueyFQo6AoYrk9k7OoK7k="},{"num_cand":"U2FsdGVkX1/5WQmwx0gZ3J4sq2ZFdvE+Jup335L/zHY=","cpf":"U2FsdGVkX1957I/wJ06KFh2p57Nk8PFYeOEsXdJmlPw="},{"num_cand":"U2FsdGVkX1+Z9V7rk2Pr4E18B0e91TOOTrDtwzRQnOE=","cpf":"U2FsdGVkX1+cqB7iNfz70SpOdujkO2VO2LlQhkdMGfo="},{"num_cand":"U2FsdGVkX1+CKoryZIbH2zZP57D0VI2IqsxfBIxGiCc=","cpf":"U2FsdGVkX1+WK/KXxDirvFuoFoK5XnuceJmVdAREXvU="},{"num_cand":"U2FsdGVkX19ZgnlfohZcrE7Juj97Zhb8kG3mSYs+kiU=","cpf":"U2FsdGVkX19xjEk1MqXRRoGbpukViYgCnVB/ms79/tE="},{"num_cand":"U2FsdGVkX18pkeAjg+D1arzbY04+zp2mZwXTDDJdLjs=","cpf":"U2FsdGVkX195hnavbz7a7tpnwCHZJCM7CnNpzq8cX1M="},{"num_cand":"U2FsdGVkX18Xtxu8XBOSxAgmd3Twx/LyyZ3U56QhC5c=","cpf":"U2FsdGVkX1/hDa4eNZogKyp90m3iJxAWwVX/t56h6SQ="},{"num_cand":"U2FsdGVkX1/kvTaU+9Caftmrsm2Rsr8AxWse2r1FQRY=","cpf":"U2FsdGVkX19j7VCdomRmzsLrA3wGokFA+0UKS38sy/o="},{"num_cand":"U2FsdGVkX1+Gaga2DPpYsaIsiBGBT0yDOm5GoU1CuOE=","cpf":"U2FsdGVkX18LTt9qT3AAUm1EzZFpIj32KeBml7FmOX4="},{"num_cand":"U2FsdGVkX19OHv9iB6k0KBm4dU6IoB6yyMCw54WKUzw=","cpf":"U2FsdGVkX19MOAbJY+00n0AIRw88BpSqpFJRiQlPDCU="},{"num_cand":"U2FsdGVkX1/ZWMz0nlCvnlaOj51GUEbCM7/aO36JKpE=","cpf":"U2FsdGVkX1+2PM81MrIypOI1qSXi0ZBd59lO7jcbyig="},{"num_cand":"U2FsdGVkX1+1WLCl6d/1qjF4CkYObwqqjkUkmd8j9no=","cpf":"U2FsdGVkX1+NJ97VcO/EdHlZVVfRFBVsVwNXmjna5hQ="},{"num_cand":"U2FsdGVkX1/4LsN3OBK+Vo+RsJGRadoEIsg/g0v4ZsU=","cpf":"U2FsdGVkX19p7q8cToQOoPOepDv65ZP7/caKYRu2UoI="},{"num_cand":"U2FsdGVkX18TTqX8orH36lZvibVDfUcSxTc4sUzDJ8s=","cpf":"U2FsdGVkX1+VgRVsLqTbbTjbrSsG5+LoqwapMZ+96e8="},{"num_cand":"U2FsdGVkX18qinShLU5CWt4RmzTYj6pzv+25jmbDKXk=","cpf":"U2FsdGVkX1+3miaoPea+zEVpfxow4uVpf4OaX12OpNM="},{"num_cand":"U2FsdGVkX18gSBIR/i+fPjEO05mug88gy7f4BQbTWuA=","cpf":"U2FsdGVkX19zMpBXteKZbkoou2rE1o5nAbCCPFR+vtQ="}]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2204/rec_discc/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
